import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const CountdownTimer = ({ seconds, onExpire, label = "Time remaining", showProgress = true }) => {
  const [timeLeft, setTimeLeft] = useState(seconds);
  
  useEffect(() => {
    setTimeLeft(seconds);
  }, [seconds]);
  
  useEffect(() => {
    if (timeLeft <= 0) {
      onExpire?.();
      return;
    }
    
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onExpire?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [timeLeft, onExpire]);
  
  const minutes = Math.floor(timeLeft / 60);
  const secs = timeLeft % 60;
  const progress = (timeLeft / seconds) * 100;
  const isWarning = timeLeft <= 30;
  const isCritical = timeLeft <= 10;
  
  return (
    <div className="flex flex-col items-center gap-2">
      <div className={`flex items-center gap-2 text-sm ${isCritical ? 'text-red-500 animate-pulse' : isWarning ? 'text-amber-500' : 'text-muted-foreground'}`}>
        <Clock className="w-4 h-4" />
        <span>{label}:</span>
        <span className="font-mono font-bold text-lg">
          {String(minutes).padStart(2, '0')}:{String(secs).padStart(2, '0')}
        </span>
      </div>
      {showProgress && (
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className={`h-full transition-all duration-1000 ease-linear ${isCritical ? 'bg-red-500' : isWarning ? 'bg-amber-500' : 'bg-primary'}`}
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default CountdownTimer;